module.exports = __webpack_public_path__ + "img/web-development.f6e54d53.png";